import React from 'react';
import { LoginComponent } from '../Components/Login';
export const Login = (props) => {
  return (
    <div>
      <LoginComponent {...props} />
    </div>
  );
};
